import React from 'react';
import { KFLLayout } from '@kamstrup/kamstrup-frontend-library';
import TopHeader from '../layout/topheader';
import Menu from '../layout/menu';
import { AppKeys } from '../../core/localization';

const LoadingPage: React.FC = () => {
  const content = (
    <div className="layout__content__withmargins">
      <p></p>
    </div>
  );
  return (
    <KFLLayout
      topbar={<TopHeader />}
      content={content}
      menu={<Menu title={AppKeys.Com_Loading} />}
      isSidebarDisabled={false}
    />
  );
};

export default LoadingPage;
